import React, { useEffect, useState } from "react";
import Marquee from "react-fast-marquee";
import { getHotels } from "@/lib/api";
import { useHome } from "@/i18n/home";

export const ClientMarquee = () => {
  const label = useHome().trust.clients;
  const [hotels, setHotels] = useState([]);
  useEffect(() => {
    getHotels().then(setHotels).catch(() => setHotels([]));
  }, []);
  if (!hotels.length) return null;
  return (
    <section className="relative border-y border-[#E3ECF2] bg-white/90 py-8 backdrop-blur-md sm:py-10" data-testid="client-marquee">
      <div className="mx-auto flex max-w-[1400px] flex-col gap-4 px-5 sm:px-8 md:flex-row md:items-center md:gap-8">
        <p className="shrink-0 text-xs font-bold uppercase tracking-[0.2em] text-[#0B87B0] sm:text-sm" data-testid="client-marquee-label">{label}</p>
        <div className="pt-marquee-fade min-w-0 flex-1">
          <Marquee speed={40} pauseOnHover gradient={false} autoFill>
            {hotels.map((h) => (
              <a
                key={h.id}
                href={h.website || undefined}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-8 flex h-20 items-center transition-transform duration-300 hover:scale-105 sm:mx-12 sm:h-24"
                data-testid={`client-marquee-${h.id}`}
                title={h.name}
              >
                <img src={h.logo_url} alt={h.name} className="h-14 w-auto max-w-[180px] object-contain sm:h-20 sm:max-w-[260px]" loading="lazy" />
              </a>
            ))}
          </Marquee>
        </div>
      </div>
    </section>
  );
};
